import { useAuthContext } from '../auth/useAuthContext';

export function useRole() {
    const { user } = useAuthContext();

    const role = user?.role.name || '';
    const role_id = user?.role_id || '';
    return {
        role,
        isSuperAdmin: role_id === 1,
        isAdmin: role_id === 2,
        isUser: role_id === 3,
        isAcconting: role_id === 4,
        isFinance: role_id === 5,
        isOperation: role_id === 6,
        isDirector: role_id === 7,
    };
}
